import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const RequestsContainer = styled(Box).attrs({
  borderRadius: 5,
  mt: 32,
  height: 330,
  overflow: 'auto',
})`
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
`;

export const RequestContainer = styled(Box).attrs({
  p: 16,
  flow: 4,
})`
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.heavyLineOutline}`};
  b &:last-child {
    border-bottom: none;
  }
`;
